import type { ReactNode } from 'react';

export const tableColumnsNames = [
  'id',
  'applicant',
  'coApplicant',
  'status',
  'type',
  'createdAt',
  'submittedAt',
] as (keyof ApplicationForListingDto)[];

export interface IApplicationsAnalystTableProps {
  searchInputValue: string;
}

enum ApplicationTypeEnum {
  PURCHASE = 'PURCHASE',
  REFINANCE = 'REFINANCE',
}

export type ApplicationForListingDto = {
  title: string;
  purpose: string;
  financingAmount: number;
  id: string;
  referenceNumber?: string;
  applicant?: string;
  coApplicant?: string;
  status?: string;
  type?: ApplicationTypeEnum;
  createdAt?: Date;
  updatedAt: Date;
  submittedAt?: Date;
  email?: string;
};

export interface ApplicationListingRowFormatted {
  id: string;
  caseId: string;
  applicant?: string;
  coApplicant?: string;
  status?: ReactNode;
  type?: string;
  createdAt?: Date;
  submittedAt?: Date;
}
